<template>
    <main class="background imageless_bg messages">
        <div class="pcon">
            <ProfileMenu />
            <TicketsMenu />
        </div>


    </main>
</template>

<script>
import ProfileMenu from '@/components/profile/ProfileMenu.vue'
import TicketsMenu from '@/components/TicketsMenu.vue'

export default {
    name: 'TicketsVue',
    components: { ProfileMenu, TicketsMenu, },
    data() {
        return {
            openTicket: false
        }
    },
    mounted() {
        document.title = 'Tickets / Rossoneries'

    }
}
</script>

<style></style>